import React, { useState, useRef, useEffect } from 'react';
import classNames from 'classnames';
import { Text } from '@chakra-ui/react';

import { TabMenuItem } from './TabMenuItem';
import { TabMenuContainer } from './TabMenuContainer';
import { ChevronDownIcon } from '@chakra-ui/icons';

interface TabsMenuProps {
  activeTab: string;
  activeIndex: number;
  tabs: string[];
  className: string;
  onClick: (index: number) => void;
  disabledIndexes: number[];
}

export const TabsMenu: React.FC<TabsMenuProps> = ({
  activeTab,
  activeIndex,
  tabs,
  className,
  onClick,
  disabledIndexes,
}) => {
  const [showTabMenu, setShowTabMenu] = useState(false);
  const tabMenuRef = useRef<HTMLDivElement>(null);

  const handleContainerClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setShowTabMenu(!showTabMenu);
  };

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (tabMenuRef.current && !tabMenuRef.current.contains(e.target as Node)) {
        setShowTabMenu(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  return (
    <div ref={tabMenuRef}>
      <TabMenuContainer 
        className={`v-center ${className}`}
        onClick={handleContainerClick}
      >
        <Text as="div" textStyle="caption" className="caption tab-caption">
          {activeTab}
        </Text>
        <ChevronDownIcon 
          className="tab-icon" 
          name="ExpandMore" 
          boxSize="24px"
          aria-label={showTabMenu ? "Close menu" : "Open menu"}
        />
        <div
          className={classNames(
            'tab-menu-container',
            { hidden: !showTabMenu },
            { displayed: showTabMenu },
          )}
        >
          <ul>
            {showTabMenu &&
              tabs.map((tab, i) => (
                <TabMenuItem
                  disabled={disabledIndexes.includes(i)}
                  activeIndex={activeIndex}
                  tabName={tab}
                  key={i}
                  index={i}
                  onClick={onClick}
                />
              ))}
          </ul>
        </div>
      </TabMenuContainer>
    </div>
  );
};
